import dashboard from '../views/dashboard';

export default [
  {
    path: '/dashboard',
    key: 'dashboardgroup',
    component: dashboard
  }
];
